<!-- Modal -->
<div class="modal-dialog modal-dialog-centered mail-modal transakModal">
	<div class="modal-content">
		<div class="modal-body">
			<div class="container">
				<div class="row my-4">
					<div class="col-lg-12">
						<div class="text-center">
							<div class="mb-3 transk-svg">
								<img src="assets/images/Use_Deposit.png">
							</div>
							<button class="transkclose-btn" (click)="closeTransakModal()">
								<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#000'>
									<path
										d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414' />
								</svg>
							</button>
							<div class="text-start">
								<h4 class="text-center">Add USDC to Your Wallet</h4>
								<!-- <a (click)="redirctTransackLink()" class="cursor-pointer" rel="noopener noreferrer">
                                        Click this link to buy USDC on Polygon
                                    </a>. Funds will be deposited to your wallet: -->
								<p class="mt-3 mb-2">Buy USDC on Polygon using the secure link below.</p>
								<p class="mb-4">Funds will be deposited to your wallet:</p>
								<strong>{{user?.wallet_address}}
									<span class="copytooltip-container" (click)="copy(user?.wallet_address)">
										<img src="assets/images/copy-icon.svg" alt="copy" loading="lazy"
											class="cursor-pointer">
										<span class="copytooltip-text">Copy Address</span>
									</span>
								</strong>
							</div>

						</div>
					</div>
				</div>
				<div>
						<button class="text-white sign-in-wallet" (click)="redirctTransackLink()">Buy Now.</button>
					<p class="text-center mt-3">(Secure, instant transfer to your wallet)</p>
				</div>
			</div>
		</div>
	</div>
</div>